export const CHANNEL_COLORS: Record<string, { bg: string; color: string }> = {
  EMAIL: { bg: '#DBEAFE', color: '#1D4ED8' },
  SMS: { bg: '#D1FAE5', color: '#065F46' },
  WHATSAPP: { bg: '#D1FAE5', color: '#065F46' },
  PUSH: { bg: '#FEF3C7', color: '#92400E' },
  IN_APP: { bg: '#E0E7FF', color: '#3730A3' },
  WEBHOOK: { bg: '#F3E8FF', color: '#6B21A8' },
};

export const CHANNEL_OPTIONS = ['EMAIL', 'SMS', 'WHATSAPP', 'PUSH', 'IN_APP', 'WEBHOOK'] as const;
